import type { AccordionConfig } from './accordion.types.ts';

export default {
    enableScrolling: true,
    scrollHeaderElement: '#header',
    scrollOffset: 0
} satisfies Required<AccordionConfig>;
